import { sleep } from '../../../smoothr-web-app-core/utils/utils';
import { Component, Input } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { MenuModalComponent } from '../menu-modal/menu-modal.component';
import Venue from 'src/smoothr-web-app-core/models/Venue';

@Component({
	selector: 'app-burger-btn',
	templateUrl: './burger-btn.component.html',
	styleUrls: ['burger-btn.component.scss'],
})
export class BurgerBtnComponent {
	visible: boolean;
	isOpened: boolean = false;
	@Input() venue: Venue;
	constructor(
		private popoverCtrl: PopoverController,
		private modalCtrl: ModalController
	) {}

	async presentPopover(ev: any) {
		if (this.visible) {
			return;
		}
		const popover = await this.modalCtrl.create({
			component: MenuModalComponent,
			componentProps: {
				selectedVenue: this.venue,
			},
			backdropDismiss: true,
			showBackdrop: true,
			cssClass: 'menu-modal-dialog auto-height',
		});
		popover.onWillDismiss().then(() => {
			this.visible = false;
		});
		this.visible = true;
		await sleep(200);
		await popover.present();
		return;
	}
}
